export default __webpack_public_path__ + "static/features-mobile-app-testing-lg-8ea826380644751a13a7bf9bba31e9fb.jpg";